module.exports = __webpack_public_path__ + "static/img/M-515-ZERRANO.787994d.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-515-ZERRANO.png
// module id = VOEz
// module chunks = 0